import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ReactGA from 'react-ga';
import { Path, ExternalPath } from "../../constants/path";
import { Link, Button } from "../util/Clickable";

import privacy from "../../assets/images/privacy_mark.png";

class Footer extends Component {

  componentDidUpdate = (nextProps, prevState) => {
    window.scrollTo(0,0);
  }

  render = () => {
    return (
      <footer>
        <div className="uk-section uk-section-xsmall uk-section-secondary uk-position-relative">
          <div className="uk-container uk-container-small">
            <p className="uk-text-center">
              <small>Copyright © 2018 三朝温泉観光協会・三朝温泉旅館協同組合. All Rights Reserved.</small>
            </p>
          </div>
        </div>
      </footer>
    );
  }
}


const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer))
